import { Component } from '@angular/core';
import { NavController, PopoverController } from 'ionic-angular';
import { FormBuilder, Validators } from '@angular/forms';
import { OpenAccountService } from './../../services/openAccount.service';
import { AlertService } from './../../providers/alert.service';
import { AppConfig } from '../../app/app.config';
import { LoaddingService } from '../../providers/loadding.service';
import { Clipboard } from 'clipboard/dist/clipboard.min.js';
import { RegistPage } from './../regist/regist';
import { SysconfigService } from '../../services/sysconfig.service';
import { OpenAccountSearch } from './openaccountsearch';
import { UserModel } from '../../models/user.model';
import { DailyWageSetService } from '../../services/dailywageset.service';
import { FixedExtend } from '../../config/fixed-extend';
import { StorageService } from '../../providers/storage.service';
import { List } from 'linqts';

// declare let cordova:any;
@Component({
  selector: 'page-open-account',
  templateUrl: 'open-account.html',
  providers: [OpenAccountService, DailyWageSetService, FixedExtend]
})
export class OpenAccountPage {
  // 普通开户
  dailyWagesParams = [
    { minSales: null, maxSales: null, dailyWagesPercent: null },
  ];
  //   连接开户
  dailyWagesParams2 = [
    { minSales: null, maxSales: null, dailyWagesPercent: null },
  ];
  isDailyShow: boolean = false;
  isDailyShow2: boolean = false;
  isDaily: boolean = false;
  percents = [];
  currPercent = 0;
  currMinPercentTemp;
  currMinPercent = 0;//当前用户的最小日工资比例
  currMaxPercent = 0;//当前用户的最大日工资比例
  user: UserModel;
  doSendForm = this.formBuilder.group({
    'UserType': ['', [Validators.required]],
    'UserName': ['', [Validators.required]],
    'UserPassword': ['', [Validators.required]],
    'Bonus': ['', [Validators.required]],
    DailyWagesList: ["", [Validators.required]]
  });

  linkSendForm = this.formBuilder.group({
    'UserType': ['', [Validators.required]],
    'Bonus': ['', [Validators.required]]
  });

  openWay: string;
  flag: Boolean = true;
  param = new OpenUserInput();
  // 域名地址
  domainList = [];

  constructor(
    private navCtrl: NavController,
    private openAccountService: OpenAccountService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private config: AppConfig,
    private sysconfigService: SysconfigService,
    private loadding: LoaddingService,
    private popoverCtrl: PopoverController,
    private dailyWageService: DailyWageSetService,
    private fixedService: FixedExtend,
    private storage: StorageService,
  ) { }


  ionViewDidLoad() {
    this.getPlatformLineList();
    this.getUserTypes();
    this.editbonus();
    this.openWay = "normal";
    this.getDailyWageRules()
  }
  //复制
  //TQQ 2017-03-13
  copyLink(link, $event, linkID) {
    var that = this;
    var clipboard = new Clipboard('.btn_copy_' + linkID);
    var linkb = link;
    $event.currentTarget.attributes[1].nodeValue = linkb;
    clipboard.on('success', function (e) {
      that.alertService.showAlert('复制' + link + '成功！');
      e.clearSelection();
    });
  }

  //开户类型选择
  //chen 2017-01-05
  open() {
    if (this.openWay == "normal") {
      this.flag = true;
    } else {
      this.flag = false;
      let load = this.loadding.showLoding();
      this.getRegisterLinkList().then(s => {
        this.loadding.closeLoading(load);
      }).catch(() => {
        this.loadding.closeLoading(load);
      });
    }
  }

  getDailyWageRules() {
    this.user = this.storage.read<UserModel>("User");
    this.dailyWageService
      .getDailyWageRules(this.user.UserName)
      .then((s) => {
        if (s && s.length > 0) {
          let list = new List(s)
            .OrderBy((s) => s["DailyWagesPercent"])
            .ToArray();
          this.currMinPercent = list[0]["DailyWagesPercent"];
          this.currMinPercentTemp = this.fixedService.accMul(this.currMinPercent, 100);
          if (this.currMinPercentTemp == 0) {
            this.isDaily = false;
          } else {
            this.isDaily = true;
          }
        }
      });
  }

  //开户
  //chen 2017-01-05
  //TQQ update 2017-02-24
  doOpen(obj, dailyWages) {
    var pattem = /^[a-z A-Z][\w]{5,15}$/;
    let daily = dailyWages.filter(i => i.dailyWagesPercent != null || i.maxSales != null || i.minSales != null);
    if (pattem.test(this.param.UserName) === false) {
      this.alertService.showAlert("用户名只允许英文和数字，且以英文开头，长度为6~16个字符！", '提示', false);
      return;
    }

    // 会员奖金
    this.param.Rewardoptions.forEach(item => {
      if (item.bonus == obj.Bonus) {
        this.param.reward = item.reward;
        return
      }

    });
    this.doSendForm.value.DailyWages = daily;
    const load = this.loadding.showLoding("正在开户...");
    this.openAccountService.postAddUser(obj).then(s => {
      const params = {
        username: this.param.UserName,
        bonus: this.param.Bonus,
        password: this.param.UserPwd,
        userType: obj.UserType,
        reward: this.param.reward,
      }
      if (s.Result == true) {
        let modal = this.popoverCtrl.create(OpenAccountSearch, params, {
          cssClass: "openscreen_filter",
        });
        modal.present();
        modal.onWillDismiss((data: any[]) => { });
        this.param.UserName = '';
        this.param.UserPwd = '';
        if (this.param.UserTypes && this.param.UserTypes.length > 0) {
          this.param.UserType = this.param.UserTypes[0].UserTypeCode;
        } else {
          this.param.UserType = '';
        }
        if (this.param.Rewardoptions && this.param.Rewardoptions.length > 0) {
          this.param.Bonus = this.param.Rewardoptions[0].bonus;
        } else {
          this.param.Bonus = 0;
        }
      } else {
        this.alertService.showAlert(s.Error, '提示', false);
      }
      this.loadding.closeLoading(load);
    }).catch(() => {
      this.loadding.closeLoading(load);
    });
  }

  //生成链接
  //chen 2017-01-05
  linkOpen(obj, dailyWages) {
    let daily = dailyWages.filter(i => i.dailyWagesPercent != null || i.maxSales != null || i.minSales != null);
    let load = this.loadding.showLoding("正在开户...");
    this.openAccountService.addRegisterLinkNew({ bouns: obj.Bonus, userType: obj.UserType, DailyWages: daily }).then(s => {
      if (s.Result == true) {
        this.getRegisterLinkList();
      } else {
        this.alertService.showAlert(s.Error);
      }
      this.loadding.closeLoading(load);
    }).catch(() => {
      this.loadding.closeLoading(load);
    });
  }
  //跳转开户页面
  //TQQ 2018-08-29
  openUser(key) {
    this.navCtrl.push(RegistPage, { key: key });
  }
  //获取用户类别
  //TQQ 2017-02-24
  getUserTypes() {
    this.param.UserTypes = [];
    return this.openAccountService.getUserType().then(types => {
      let usertype = this.config.getCurrentUser().UserType;
      if (usertype == "3") {
        this.param.UserTypes.push(types.find(s => s.UserTypeCode == "3"));
      } else {
        types.forEach(s => {
          if (s.UserTypeCode != "3") {
            this.param.UserTypes.push(s);
          }
        });
      }
      this.param.UserType = this.param.UserTypes[0].UserTypeCode;
    });
  }

  //获取返点
  //TQQ 2017-02-24
  editbonus() {
    this.param.Rewardoptions = [];
    let sysconfig = this.config.getSysConfig();
    let maxnum = sysconfig.ClientMaxBonus;
    if (this.config.getCurrentUser().Bonus < maxnum) {
      maxnum = this.config.getCurrentUser().Bonus;
    }
    let bonus = maxnum;
    let reward = "";
    while (bonus >= sysconfig.ClientMinBonus) {
      reward = (bonus / sysconfig.BonusGruduation * sysconfig.PerGraduation + sysconfig.BasicReward).toFixed(0) + '-' + bonus.toFixed(1);
      this.param.Rewardoptions.push({ bonus: bonus.toFixed(1), reward: reward });
      bonus = parseFloat((bonus - sysconfig.ClientGraduation).toFixed(1));
    }
    this.param.Bonus = this.param.Rewardoptions[0].bonus;
    this.param.Link = {
      bonus: maxnum,
      reward: (maxnum / sysconfig.BonusGruduation * sysconfig.PerGraduation + sysconfig.BasicReward).toFixed(0)
    };
  }

  getPlatformLineList() {
    this.sysconfigService.getPlatformLineList().then(res => {
      if (res) {
        res.forEach(e => {
          if (e.LineType == 1) {
            this.domainList.push(e);
          }
        });
      }
    }).catch(err => { this.domainList = []; })
  }


  //获取开户连接的列表
  //TQQ 2017-02-24
  getRegisterLinkList() {
    return this.openAccountService.getRegisterLinkList().then(s => {
      this.param.LinkList = s;
      if (this.param.LinkList.length > 0) {
        this.param.LinkList.forEach(l => {

          let protocol = window.location.protocol;
          let host = window.location.host;
          let u = protocol + '//' + host;

          l.LinkUrl = u + "/?Key=" + l.Link;
          // if (this.domainList.length > 0) {
          //   l.LinkUrl = this.domainList[0].LineUrl + "/Regist?Key=" + l.Link;
          // } else {
          //   l.LinkUrl = "https://888.xb554.net/Regist?Key=" + l.Link;
          // }
        });
      }
    }).catch(err => {
      console.log(err);
    });
  }

  // 普通开户添加日工资
  newWages() {
    let addDaily = { minSales: null, maxSales: null, dailyWagesPercent: null };
    this.dailyWagesParams.push(addDaily);
  }
  del(obj) {
    let i = this.dailyWagesParams.indexOf(obj);
    this.dailyWagesParams.splice(i, 1);
  }
  dailyShow() {
    this.isDailyShow = !this.isDailyShow;
  }
  // 链接开户添加小时工资
  newWages2() {
    let addDaily2 = { minSales: null, maxSales: null, dailyWagesPercent: null };
    this.dailyWagesParams2.push(addDaily2);
  }
  // 链接开户删除小时工资
  del2(obj) {
    let i = this.dailyWagesParams2.indexOf(obj);
    this.dailyWagesParams2.splice(i, 1);
  }
  dailyShow2() {
    this.isDailyShow2 = !this.isDailyShow2;
  }
  //删除注册链接
  //TQQ 2017-02-24
  removeLink(id) {
    const load = this.loadding.showLoding("正在删除...");
    return this.openAccountService.removeLink(id).then(s => {
      this.loadding.closeLoading(load);
      if (s.Result) {
        this.alertService.showAlert(s.Error);
        this.getRegisterLinkList();
      }
    }).catch(() => {
      this.loadding.closeLoading(load);
    });
  }

}



//TQQ 2017-02-24
export class OpenUserInput {
  UserTypes = [];//用户类别
  UserType = "";
  Rewardoptions = [];//彩票返点
  Bonus = 0;
  UserName = "";
  UserPwd = "";
  Link = {};
  LinkList = [];
  reward: '';
}




// WEBPACK FOOTER //
// ./src/pages/open-account/open-account.ts